import { Card } from '../../atoms/Card';
import { TabSelector } from '../../molecules/TabSelector';
import { RecentUserItem } from '../../molecules/RecentUserItem';
import type { RecentUser } from '../../../services';

export interface RecentUsersListProps {
  users: RecentUser[];
  period: 1 | 7;
  onPeriodChange: (period: 1 | 7) => void;
  loading?: boolean;
  error?: string | null;
}

export const RecentUsersList = ({
  users,
  period,
  onPeriodChange,
  loading = false,
  error = null,
}: RecentUsersListProps) => {
  return (
    <Card
      title="Yeni Üyeler"
      className="bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50"
    >
      <TabSelector
        options={[
          { value: 1, label: 'Son 1 Gün' },
          { value: 7, label: 'Son 7 Gün' },
        ]}
        value={period}
        onChange={(value) => onPeriodChange(value as 1 | 7)}
        className="mb-6"
      />

      {loading ? (
        <div className="text-center text-gray-500 py-8">Yükleniyor...</div>
      ) : error ? (
        <div className="text-center text-red-500 py-8">{error}</div>
      ) : users.length === 0 ? (
        <div className="text-center text-gray-500 py-8">
          Son {period} gün içinde üye olan kullanıcı bulunmuyor
        </div>
      ) : (
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {users.map((user) => (
            <RecentUserItem key={user.id} user={user} period={period} />
          ))}
        </div>
      )}
    </Card>
  );
};
